import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import "../../assets/css/pages/orders.css";
import dayjs from "dayjs";
import {DATE_FORMAT} from "../../Constants/Constants";
import {useForm} from "react-hook-form";
import DateInput from "../../Components/Inputs/DateInput";

const endDate = dayjs();
const startDate = endDate.startOf('month');

export default function () {
  const location = useLocation();

  const ordersFilters = location.state;

  const {register, control, watch, getValues} = useForm({
    defaultValues: {
      'refundedOrders' : {
        date_from: ordersFilters?.date_from ? ordersFilters?.date_from : startDate.format(DATE_FORMAT),
        date_to: ordersFilters?.date_to ? ordersFilters?.date_to : endDate.format(DATE_FORMAT)
      },
    }
  });

  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  let filters;

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;
    filters = {...getValues()};

    let table = $('#refunded_orders').DataTable({
      "destroy": true,
      "ajax": {
        url: `${baseUrl}dashboard/refunded_orders`,
        data: filters,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
                .then(res => {
                  localStorage.removeItem('persist:root');
                  navigate('/login');
                });
          }
        }
      },
      "columns": [
        {
          data: 'order_id', name: 'Order Id', orderable: true,
          render: function (data, type, row) {
            return `<a href="/orders/${row.order_id}" target="_blank" type="button" class="btn btn-link ls-1 text-hover-primary fs-6 fw-normal ellipsis edit" row-id="${row.order_id}">
                                   ${row.order_id}
                                </a>`;
          }
        },
        {data: 'payment.price', name: 'Refund Amount', orderable: true},
        {data: 'created_at', name: 'Date', orderable: true},
      ],
        "order": [[2, "desc"]],
    });

    table.off('click');

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
      });
      $(".form-label-checkbox #mark-all").click().click();
    });
  }, [JSON.stringify(watch(['refundedOrders.date_from', 'refundedOrders.date_to']))]);


  return (<>
    <div>
      <div className="row orders-filters">
        <DateInput
            label="Date from - mm/dd/yyyy"
            name="refundedOrders.date_from"
            parentClasses="col-xxl-3 col-lg-6 mb-5"
            labelClasses="fs-7"
            title="mm/dd/yyyy"
            register={register}
        />

        <DateInput
            label="Date to - mm/dd/yyyy"
            name="refundedOrders.date_to"
            parentClasses="col-xxl-3 col-lg-6 mb-5"
            labelClasses="fs-7"
            title="mm/dd/yyyy"
            register={register}
        />
      </div>
      <table id="refunded_orders" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>Order Id</th>
          <th>Refund Amount</th>
          <th>Date</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  </>);
}